import { AppError } from './libraries/app-error';

export class BadRequestError extends AppError {}
